import application from 'application/application';

const controller = 'DefaultAddAutomaticProcessesController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$stateParams',
	'$timeout',
	'$state',
	'API',
	'helper',
	'permissions',
	'notification',
	'authentication',
	(
		$scope,
		$rootScope,
		$http,
		$stateParams,
		$timeout,
		$state,
		API,
		helper,
		permissions,
		notification,
		authentication
	) => {
		/** */
		// $scope.currentTab = 'encontrados-publicacao';

		$scope.currentTab = 'encontrados-individual';
		/** */

		$scope.loadingPage = true;
		$scope.topButton = false;
		$scope.printing = false;
		$scope.OabTabLoadingNewPage = false;
		$scope.hasOabQuickRegister = false;

		$scope.activeTab = 1;

		$scope.groupSelected = localStorage.getItem('__groupSelected__');
		$scope.tabOabProcessesList = [];

		const groupUserData = JSON.parse(localStorage.getItem('__groupUserData__'));

		const idProdutoAdvise = parseInt(
			authentication.getUserData('idProdutoAdvise')
		);

		$scope.showVideo = false;

		let user = JSON.parse(localStorage.getItem('__authenticationUserData__'));

		if (user.flUsuarioAdministrador == 'true')
			$scope.mensagenInfo =
				'Lembre-se que o administrador pode distribuir os créditos entre os usuários e mesmo assim utilizar o total de créditos contratados.';
		else
			$scope.mensagenInfo =
				'Os créditos para usuários foram fornecidos pelo usuário administrador do contrato, caso precise de mais créditos contatar o responsável para distribuição de novos créditos em sua conta.';

		$scope.clientUserJudicialOrgansList = helper.responseStore();
		$scope.requestedProcessesSourcesParams = helper.responseStore();

		$scope.buscaTribunal = '';

		// IdClassifRetornoSpider
		// HOM/PROD -> 1,2,3,4
		// DEV			-> 6,7,8,9
		$scope.sitClassifRetornoSpiders = [
			{
				id: '0',
				idClassifRetornoSpider: null,
				description: 'Buscando informações',
				idSituacaoPesquisaProcessoUsuarioCliente: '-5'
			},
			{
				id: '1',
				idClassifRetornoSpider: '1',
				description: 'Ainda não encontradas',
				idSituacaoPesquisaProcessoUsuarioCliente: '-6',
				possuiFonteProcesso: false
			},
			{
				id: '2',
				idClassifRetornoSpider: '4',
				description: 'Não encontradas',
				idSituacaoPesquisaProcessoUsuarioCliente: '-6'
			},
			{
				id: '3',
				idClassifRetornoSpider: '2',
				description: 'Restritas ou sigilosa',
				idSituacaoPesquisaProcessoUsuarioCliente: '-6'
			},
			{
				id: '4',
				idClassifRetornoSpider: '3',
				description: 'Arquivadas ou encerradas',
				idSituacaoPesquisaProcessoUsuarioCliente: '-6'
			},
			{
				id: '5',
				idClassifRetornoSpider: null,
				description: 'Movimentado',
				idSituacaoPesquisaProcessoUsuarioCliente: '-6',
				possuiFonteProcesso: true,
				movimentado: true
			}
		];

		$scope.titleCourts = 'Todos tribunais';
		$scope.titleSources = 'Todas fontes';

		$scope.briefcase = helper.responseStore().setItemsPerPage(1);

		$scope.previousFilterSources = '';
		$scope.filterSources = '';
		$scope.lastSources = [];
		$scope.hasCourtsRequest = false;
		$scope.hasCourtsScrollListener = false;

		$scope.courtsPage = {
			paginaAtual: 1,
			paginaTotal: 1,
			registrosPorPagina: 10,
			registrosTotal: 10
		};

		$scope.completedSearchCourts = false;

		$scope.requestingFilter = false;
		$scope.disableFilter = true;
		$scope.finishedFilterLoading = true;
		$scope.finishedSourcesLoading = true;

		$scope.scrollTop = () => {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		};

		$scope.onInit = () => {
			let storageActiveTab = localStorage.getItem('__activeTab__');

			if (
				storageActiveTab &&
				(storageActiveTab == '1' || storageActiveTab == '2')
			) {
				$scope.activeTab = Number(storageActiveTab);
			}
		};

		// Função seta a cor do background vinda do objeto

		$scope.getBackgroundColor = color => {
			const colorBackground = { 'background-color': color };

			return colorBackground;
		};

		const hasToShowVideo = () => {
			setTimeout(() => {
				$scope.showVideo =
					!permissions.has('processesWithAutomaticMovementsSearch') &&
					idProdutoAdvise &&
					idProdutoAdvise == '-3'
						? true
						: false;
			}, 1000);
		};

		hasToShowVideo();

		/** */
		$scope.foundProcessesIndividual = helper
			.responseStore()
			.setItemsPerPage(20);

		/** Lista de filtros possíveis. */
		let processesFiltersNames = ['situacao', 'orgaoJudicial', 'fonte'];

		$scope.filter = {
			situacao: $stateParams.situacao ? $stateParams.situacao : '',
			orgaoJudicial: $stateParams.orgaoJudicial
				? $stateParams.orgaoJudicial
				: '',
			fonte: $stateParams.fonte ? $stateParams.fonte : ''
		};
		/** Define os filtros informados na URL. */
		processesFiltersNames.forEach(name => {
			let value = $stateParams[name];

			if (value !== undefined)
				$scope.foundProcessesIndividual.setFilter(name, value, true);
		});

		$scope.fetchTabOabProcesses = () => {
			$scope.hasOabQuickRegister = permissions.has('oabQuickRegister');

			if ($scope.hasOabQuickRegister) {
				$http({
					...helper.http(API.quickRegister, 'getInfoSearch'),
					method: 'GET',
					params: {}
				}).then(({ data }) => {
					if (data.status && data.status.codigo == 200) {
						$scope.tabOabProcessesList = data.itens;
					}
				});
			}
		};

		$scope.fetchTabOabProcesses();

		const recordFoundProcessesIndividual = (
			responseStore,
			callback = () => {}
		) => {
			const processes = $scope.foundProcessesIndividual.items.length;

			$scope.verifyLoader = processes != 0 && processes < 20 ? false : true;

			if (!$scope.verifyLoader || $scope.topButton) {
				return false;
			}

			$scope.processloading = true;

			let filters = {
				...helper.httpFields(['*']),
				paginaAtual: responseStore.getCurrentPage(),
				registrosPorPagina: responseStore.getItemsPerPage()
			};

			if (!!$scope.filter.situacao) {
				const {
					idClassifRetornoSpider,
					idSituacaoPesquisaProcessoUsuarioCliente,
					possuiFonteProcesso,
					movimentado
				} = $scope.sitClassifRetornoSpiders[$scope.filter.situacao];

				filters.idSituacaoPesquisaProcessoUsuarioCliente = idSituacaoPesquisaProcessoUsuarioCliente;
				filters.idsClassifRetornoSpider = idClassifRetornoSpider;
				filters.possuiFonteProcesso = possuiFonteProcesso;
				filters.movimentado = movimentado;
			} else {
				filters.idSituacaoPesquisaProcessoUsuarioCliente = '-5,-6';
			}

			if ($scope.groupSelected == 'true') {
				filters = Object.assign(filters, {
					idGrupoUsuarios: groupUserData.idGrupo
				});
			}

			if (!!$scope.filter.orgaoJudicial) {
				filters.idsOrgaoJudiciario = $scope.filter.orgaoJudicial;
			}

			if (!!$scope.filter.fonte) {
				filters.idsFontePesquisa = $scope.filter.fonte;
			}

			$http({
				...helper.http(API.foundProcesses, 'GET'),
				params: filters
			})
				.then(response => {
					const totalProcess = response.data.itens.length;

					if (totalProcess === 0 && processes > 20) $scope.topButton = true;

					response.data.itens = response.data.itens.map(proc => ({
						...proc,
						fontes: proc.fontes.sort((fontA, fontB) => {
							const fontADate = fontA.dataHoraUltSolic;
							const fontBDate = fontB.dataHoraUltSolic;

							if (fontADate > fontBDate) return -1;

							if (fontADate < fontBDate) return 1;

							return 0;
						})
					}));

					response.data.itens.sort((processA, processB) => {
						const processADate = processA.fontes[0].dataHoraUltSolic;
						const processBDate = processB.fontes[0].dataHoraUltSolic;

						if (processADate > processBDate) return -1;

						if (processADate < processBDate) return 1;

						return 0;
					});

					if (responseStore.getCurrentPage() === 1)
						responseStore.setItems(response.data.itens);
					else responseStore.pushItems(response.data.itens);

					callback();
				})

				.finally(() => {
					responseStore.setReady(true);

					$scope.processloading = false;

					$scope.loadingPage = false;

					$scope.finishedLoading = true;
				});
		};

		recordFoundProcessesIndividual($scope.foundProcessesIndividual);

		$scope.togglePeople = source => (source.__showAllPeople = true);

		/** */

		$scope.openHeader = (source, modal) => {
			$scope.printing = true;

			$http({
				...helper.http(API.processHeaders, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idFontePesquisaProcesso: source.id
				}
			}).then(response => {
				source.dadosCabecalho =
					response.data.itens[0].fontesProcesso[0].dadosCabecalho;

				source.tiposSujeitos =
					response.data.itens[0].fontesProcesso[0].tiposSujeitos;

				$scope.printing = false;

				$timeout(() => $(`${modal}-${source.id}`).modal('show'));
			});
		};

		/** */

		$scope.createFolders = (processes, type = 'all') => {
			$scope.printing = true;
			let idSources = [];
			const selectedProcesses = [];

			processes.items.forEach(process => {
				process.checked && selectedProcesses.push(process);
				process.fontes.forEach(
					source => source.checked && idSources.push(source.id)
				);
			});

			if (type === 'all' || type === 'individual') createFolder(idSources);

			function createFolder(processesSearchSourcesIds = []) {
				let items = {
					idTipoPasta: -3,
					IdsFontesPesquisaProcesso: processesSearchSourcesIds
				};

				if ($scope.groupSelected == 'true') {
					items = Object.assign(items, {
						idGrupoUsuarios: groupUserData.idGrupo
					});
				}

				const request = $http({
					...helper.http(API.briefcase, 'POST'),
					data: {
						itens: [items]
					},
					messageOverride: {
						success(response, notify) {
							notify.success('Processo cadastrado!');
						}
					}
				});

				request.then(response => {
					const { itens } = response.data;

					// let folderId = Array.isArray(itens) ? itens[0][0].id : itens[0].id;

					let { id } = itens[0];

					$state.go('root.default.movements.list4', {
						pasta: id
					});
				});

				return request;
			}
		};

		/** Recupera todas as fontes de um processos que estão checadas */

		$scope.getCheckedItems = (item, children, prop = 'checked') => {
			return item[children].filter(
				child => child[prop] && child.disabled != 'disabled'
			);
		};

		$scope.openModal = (fontProcess, process, item) => {
			const fontesCheck = process.fontes.filter(item => item.checked);

			const tipoInfo =
				fontesCheck.length === process.fontes.length ? true : false;

			var textTitle = [];
			var textBoby = [];
			var textBtn = [];

			if (item || !tipoInfo) {
				textTitle = 'a fonte(s) deste processo';
				textBoby = 'a fonte(s) ';
				textBtn = 'fontes(s)';
			} else {
				textTitle = 'este processo e suas fontes';
				textBoby = 'o processo e fontes';
				textBtn = 'processo';
			}

			$scope.modalTitle = `Deseja excluir ${textTitle}?`;

			$scope.modalBoby = `Ao excluir ${textBoby} da Central de Buscas, você opta por removê-los da listagem. Você poderá buscá-los novamente realizando o cadastro do processo.`;

			$scope.btnConfirmarModal = `Sim, quero excluir ${textBtn}`;

			$scope.fontProcess = fontProcess;
			$scope.process = process;
			$scope.singleSource = item;

			$('#modalDeleteFont').modal('show');
		};

		/** Deletar (alterar status) de um ou mais fontes */

		$scope.deleteSourceIndividual = (responseStore, process, item) => {
			var ids = [];

			if (item === 'individual') {
				ids[0] = responseStore.id;
			} else {
				ids = process.fontes.filter(f => f.checked).map(f => f.id);
			}

			$http({
				...helper.http(API.userCustomerAutomaticSearch, 'PUT'),
				data: {
					itens: [
						{
							idSituacaoPesquisaProcesso: -8,
							idsFontesPesquisaProcesso: ids
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						let msg =
							ids.length > 1
								? 'As fontes foram excluídas!'
								: 'A fonte foi excluída!';

						notify.success(msg);
					}
				}
			}).then(() => {
				const checkedTrueCount = (process.fontes || []).filter(f => f.checked)
					.length;

				if (item) {
					// remove apenas a fonte individual
					process.fontes = process.fontes.filter(
						f => f.id !== responseStore.id
					);
					process.checked = false;
				} else if (
					process.fontes.length ===
					$scope.getCheckedItems(process, 'fontes').length
				) {
					// se todos os itens do processo estavam marcados, remove o processo do store
					responseStore.getItems().forEach((it, index) => {
						if (it.id === process.id) responseStore.items.splice(index, 1);
					});
				} else {
					// remove apenas os itens marcados
					process.checked = false;
					process.fontes = process.fontes.filter(f => !f.checked);
				}

				// --- Desmarcar TODOS os checkboxes remanescentes deste processo ---
				process.checked = false;
				(process.fontes || []).forEach(f => {
					f.checked = false;
				});

				// --- Ajustar contador global de selecionados (se você usa esse controle) ---
				// Subtrai o que estava marcado neste processo; como zeramos tudo, faz sentido.
				if (typeof $scope.controllerCheck === 'number') {
					$scope.controllerCheck = Math.max(
						0,
						($scope.controllerCheck || 0) - checkedTrueCount
					);
				}

				helper.defer(() => $scope.$apply());
				$('.modal').modal('hide');
			});
		};

		$scope.filterIgnorarJuiz = item => {
			let r = true;

			item.sujeitos.map(i => {
				if (i.idTipoSujeitoProcesso == -4) r = false;
			});

			return r;
		};

		$scope.filterApenasJuiz = item => {
			let r = false;

			item.sujeitos.map(i => {
				if (i.idTipoSujeitoProcesso == -4) r = true;
			});

			return r;
		};

		$scope.creditPlan;

		$scope.creditPlanLoading = true;

		$scope.recordCreditPlan = () => {
			$scope.creditPlanLoading = true;

			$http({
				...helper.http(API.userClientFunctionalities, 'GET'),
				params: {
					idFuncionalidade: -32
				}
			})
				.then(response => {
					$scope.creditPlan = response.data.itens[0];

					$scope.statusPlan = response.data.status.codigo;
				})

				.finally(() => {
					$scope.creditPlanLoading = false;
				});
		};

		$scope.recordCreditPlan();

		/** */

		{
			let busy = false,
				responseStore = $scope.foundProcessesIndividual;

			$scope.foundProcessesIndividualNextPage = () => {
				if (!busy) {
					busy = true;

					responseStore.setCurrentPage(responseStore.getCurrentPage() + 1);

					recordFoundProcessesIndividual(responseStore, () => (busy = false));
				}
			};
		}

		$scope.expandProcess = process => {
			process.expanded = !process.expanded;
		};

		$scope.controllerCheck = 0;
		$scope.toggleCheck = id => {
			const element = document.getElementById(id);

			const itemChecked = element.checked;

			if (itemChecked) {
				$scope.controllerCheck++;
			} else {
				$scope.controllerCheck -= 1;
				$scope.disCheckbox = false;
			}

			if ($scope.controllerCheck === $scope.creditPlan.qtdDisponivel) {
				notification.danger('Os créditos disponíveis acabaram!');
				$scope.disCheckbox = true;
			}
		};

		$scope.toggleCheckBatch = (id, lote) => {
			$scope.checkDisebleBatchId = id;

			$scope.batchProcess = lote;

			const element = document.getElementById(id).checked;

			const situation = lote.fontes.filter(
				item => item.idSitPesqProcUsuarioCliente !== -5
			);

			const counter = situation.filter(process => process.checked === true);

			$scope.totalBatch = $scope.controllerCheck + situation.length;

			if ($scope.totalBatch > $scope.creditPlan.qtdDisponivel && element) {
				$('#modalInfo').modal('show');
			}

			if (counter.length === $scope.controllerCheck && !element) {
				$scope.controllerCheck = 0;
			} else if (!element) {
				$scope.controllerCheck -= counter.length;
			} else if (element) {
				$scope.creditosTotal = $scope.controllerCheck;
				$scope.controllerCheck = $scope.totalBatch;
			}

			if ($scope.controllerCheck === $scope.creditPlan.qtdDisponivel) {
				$scope.disCheckbox = true;
				notification.danger('Os créditos disponíveis acabaram!');
			} else {
				$scope.disCheckbox = false;
			}
		};

		$scope.closeModalInfo = () => {
			// $scope.batchProcess.checked = false;

			// $scope.disCheckbox = false;

			// $scope.batchProcess.fontes.map(item => (item.checked = false));

			// $scope.controllerCheck = $scope.creditosTotal;

			$('#modalInfo').modal('hide');
		};

		$scope.hasSource = sources => {
			let hasSource = sources.some(x => x.idSitPesqProcUsuarioCliente != -5);

			return hasSource;
		};

		$scope.getScroll = () => {
			$(window).scroll(function() {
				const limit = $scope.hasOabQuickRegister ? 302 : 180;

				if ($(this).scrollTop() > limit) {
					$('#side-bar-info').addClass('scroll-process-animation');
				} else {
					$('#side-bar-info').removeClass('scroll-process-animation');
				}
			});
		};

		$scope.filterProcesses = () => {
			$scope.disableFilter = false;

			$scope.recordRequestedProcessesSourcesParams();
		};

		$scope.filterCourts = () => {
			$scope.disableFilter = false;
			$scope.requestedProcessesSourcesParams.setReady(false);

			$scope.recordRequestedProcessesSourcesParams();
		};

		$scope.filterFonts = () => {
			$scope.disableFilter = false;
		};

		$scope.expandedCourts = () => {
			var checkboxes = document.getElementById('checkboxesCourts');
			var arrow = document.getElementById('arrowCourts');

			setTimeout(() => {
				$scope.closeCourts(checkboxes, arrow);
			}, 100);

			if ($scope.clientUserJudicialOrgansList.hasNotItems()) $scope.getCourts();

			if (!$scope.expandedCourtsFilter) {
				checkboxes.style.display = 'block';
				$scope.expandedCourtsFilter = true;

				arrow.style.transform = 'rotate(180deg)';

				$scope.addListenerToScroll();
			} else {
				checkboxes.style.display = 'none';
				$scope.expandedCourtsFilter = false;

				arrow.style.transform = 'rotate(360deg)';
			}
		};

		/** Método que fecha filtro de tribunais personalidado */
		$scope.closeCourts = (checkboxes, arrow) => {
			$(document).on('click', function(e) {
				if ($(e.target).is('.clickoutCampanha')) return;

				if (!$(e.target).is('.searchingCourts')) {
					if ($scope.expandedCourtsFilter === true) {
						checkboxes.style.display = 'none';
						$scope.expandedCourtsFilter = false;
						arrow.style.transform = 'rotate(360deg)';
					}
				}
			});
		};

		$scope.getCourts = () => {
			$scope.recordRequestedProcessesJudicialOrgans();
		};

		$scope.courtsSearch = '';
		$scope.courtsClose = false;

		/** Método para pesquisa de palavra chave dentro do filtro */
		$scope.courtsPesq = async courts => {
			if (courts.length > 2) {
				let buscaTribunalAntigo = $scope.buscaTribunal;

				$scope.buscaTribunal = courts;
				if (buscaTribunalAntigo != $scope.buscaTribunal) {
					$scope.recordRequestedProcessesJudicialOrgans();
				}

				if (!$scope.guardCourts)
					$scope.guardCourts = helper.cloneSimpleObject(
						$scope.clientUserJudicialOrgansList.getItems()
					);

				let record = $scope.guardCourts.filter(item => {
					return (
						item.nomeOrgaoJudiciario
							.toLowerCase()
							.indexOf(courts.toLowerCase()) > -1
					);
				});

				$scope.clientUserJudicialOrgansList.setItems(record);

				record.length ? ($scope.notCourts = false) : ($scope.notCourts = true);

				if (courts.length) $scope.courtsClose = true;
			} else if (!courts.length && $scope.guardCourts) {
				let buscaTribunalAntigo = $scope.buscaTribunal;

				$scope.buscaTribunal = '';
				if (buscaTribunalAntigo != $scope.buscaTribunal) {
					$scope.recordRequestedProcessesJudicialOrgans();
				}

				$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);
				$scope.notCourts = false;
				$scope.courtsClose = false;
			} else {
				let buscaTribunalAntigo = $scope.buscaTribunal;

				$scope.buscaTribunal = '';
				if (buscaTribunalAntigo != $scope.buscaTribunal) {
					$scope.recordRequestedProcessesJudicialOrgans();
				}
			}
		};

		$scope.sourcesPesq = async sources => {
			if (sources.length > 2) {
				if (!$scope.guardSources)
					$scope.guardSources = helper.cloneSimpleObject(
						$scope.requestedProcessesSourcesParams.getItems()
					);

				let record = $scope.guardSources.filter(item => {
					return (
						item.nomeFontePesquisa
							.toLowerCase()
							.indexOf(sources.toLowerCase()) > -1
					);
				});

				$scope.requestedProcessesSourcesParams.setItems(record);

				record.length
					? ($scope.notSources = false)
					: ($scope.notSources = true);

				if (sources.length) $scope.sourcesClose = true;
			} else if (!sources.length && $scope.guardSources) {
				$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);
				$scope.notSources = false;
				$scope.sourcesClose = false;
				$scope.guardSources = null;
			}
		};

		$scope.clearBuscaFontes = () => {
			setTimeout(() => {
				$scope.sourcesSearch = '';
				$scope.notSources = false;
				$scope.sourcesClose = false;

				const el = document.getElementById('inputBuscaFontes');

				if (!el) return;

				el.value = '';

				if (!$scope.$$phase) $scope.$apply();
			}, 50);
		};

		$scope.clearBuscaTribunais = () => {
			setTimeout(() => {
				$scope.courtsSearch = '';
				$scope.courtsClose = false;

				$scope.filter.composedId = '';

				if ($scope.guardCourts && $scope.guardCourts.length) {
					$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);
					$scope.notCourts = false;
				}

				const el = document.getElementById('inputBuscaTribunais');

				if (!el) return;

				el.value = '';

				if (!$scope.$$phase) $scope.$apply();
			}, 50);
		};

		$scope.courtsSelected = organs => {
			$scope.filter.orgaoJudicial = organs.idOrgaoJudiciario;
			$scope.titleCourts = organs.nomeOrgaoJudiciario;

			$scope.titleSources = 'Todas fontes';

			$scope.expandedCourts();

			$scope.filter.composedId = '';

			setTimeout(() => {
				$scope.recordRequestedProcessesSourcesParams();
			}, 100);
		};

		$scope.btnClearCourts = () => {
			if ($scope.guardCourts)
				$scope.clientUserJudicialOrgansList.setItems($scope.guardCourts);

			$scope.filter.orgaoJudicial = '';
			$scope.filter.fonte = '';
			$scope.filter.composedId = '';

			$scope.titleCourts = 'Todos tribunais';
			$scope.titleSources = 'Todas fontes';
			$scope.sourcesClose = false;
			$scope.sourcesSearch = '';
			$scope.courtsClose = false;
			$scope.courtsSearch = '';

			$scope.courtsPesq($scope.courtsSearch);

			const el = document.getElementById('inputBuscaTribunais');

			if (el && el.value) {
				el.value = '';
			}

			if ($scope.expandedCourtsFilter) {
				var checkboxes = document.getElementById('checkboxesCourts');
				var arrow = document.getElementById('arrowCourts');

				checkboxes.style.display = 'none';
				$scope.expandedCourtsFilter = false;

				arrow.style.transform = 'rotate(360deg)';
			}

			setTimeout(() => {
				$scope.applyFilters($scope.filter, $scope.foundProcessesIndividual);
			});
		};

		$scope.clearTextSources = () => {
			$scope.filter.fonte = '';
			$scope.filter.composedId = '';

			$scope.sourcesSearch = '';
			$scope.sourcesClose = false;
			$scope.titleSources = 'Todas fontes';

			if ($scope.guardSources && $scope.guardSources.length) {
				$scope.requestedProcessesSourcesParams.setItems($scope.guardSources);
				$scope.notSources = false;
			}

			const el = document.getElementById('inputBuscaFontes');

			if (el && el.value) {
				el.value = '';
			}

			if (!$scope.$$phase) $scope.$apply();
		};

		$scope.btnClearSources = () => {
			$scope.filter.fonte = '';
			$scope.filter.composedId = '';

			$scope.titleSources = 'Todas fontes';
			$scope.sourcesClose = false;
			$scope.sourcesSearch = '';

			const el = document.getElementById('inputBuscaFontes');

			if (el && el.value) {
				el.value = '';
			}

			if ($scope.expandedSourcesFilter) {
				var checkboxes = document.getElementById('checkboxesSources');
				var arrow = document.getElementById('arrowSources');

				checkboxes.style.display = 'none';
				$scope.expandedSourcesFilter = false;
				arrow.style.transform = 'rotate(360deg)';
			}

			setTimeout(() => {
				$scope.applyFilters($scope.filter, $scope.foundProcessesIndividual);
			});
		};

		$scope.openSituation = () => {
			if ($scope.expandedCourtsFilter) {
				var checkboxes = document.getElementById('checkboxesCourts');
				var arrow = document.getElementById('arrowCourts');

				checkboxes.style.display = 'none';
				$scope.expandedCourtsFilter = false;

				arrow.style.transform = 'rotate(360deg)';
			}

			if ($scope.expandedSourcesFilter) {
				var checkboxes = document.getElementById('checkboxesSources');
				var arrow = document.getElementById('arrowSources');

				checkboxes.style.display = 'none';
				$scope.expandedSourcesFilter = false;
				arrow.style.transform = 'rotate(360deg)';
			}
		};

		$scope.btnClearSituation = () => {
			$scope.filter.situacao = '';

			$scope.filterProcesses($scope.filter);

			// Faz o select2 se atualizar
			setTimeout(() => {
				const el = document.getElementById('situacao');

				if (el) {
					$(el)
						.val('')
						.trigger('change');
				}

				$scope.applyFilters($scope.filter, $scope.foundProcessesIndividual);
			});
		};

		$scope.recordRequestedProcessesJudicialOrgans = () => {
			$scope.$applyAsync(() => {
				$scope.clientUserJudicialOrgansList.setReady(false);

				$scope.completedSearchCourts = false;

				$scope.clientUserJudicialOrgansList.setItems([]);
			});

			$http({
				...helper.http(API.requestedProcessesJudicialOrgans, 'GET'),
				params: {
					SituacoesPesquisa: '-5,-6',
					campos: 'idOrgaoJudiciario,nomeOrgaoJudiciario,siglaOrgaoJudiciario',
					paginaAtual: 1,
					registrosPorPagina: 10,
					NomeOrgaoJudiciario: $scope.buscaTribunal
				}
			})
				.then(response => {
					const itens = (response.data && response.data.itens) || [];

					$scope.courtsPage = response.data.paginacao;

					$scope.clientUserJudicialOrgansList.setItems(itens);

					if ($stateParams.orgaoJudicial) {
						const o = itens.filter(
							o => o.idOrgaoJudiciario == $stateParams.orgaoJudicial
						);

						if (o.length === 1)
							$scope.recordsFilters.nomeOrgaoJudiciario =
								o[0].nomeOrgaoJudiciario;
					}
				})
				.finally(() => {
					$scope.$applyAsync(() => {
						$scope.clientUserJudicialOrgansList.setReady(true);

						$scope.completedSearchCourts = true;
					});

					if ($stateParams.orgaoJudicial) {
						$scope.titleCourts = $scope.clientUserJudicialOrgansList
							.getItems()
							.filter(
								item => item.idOrgaoJudiciario == $stateParams.orgaoJudicial
							)[0].nomeOrgaoJudiciario;
					}

					$scope.clientUserJudicialOrgansList.hasItems()
						? ($scope.notCourts = false)
						: ($scope.notCourts = true);

					setTimeout(() => {
						$scope.addListenerToScroll();
					}, 100);
				});
		};

		$scope.recordRequestedProcessesJudicialOrgans();

		$scope.changedSources = () => {
			$scope.requestedProcessesSourcesParams.setReady(false);

			$scope.recordRequestedProcessesSourcesParams();
		};

		/** Método que fecha filtro de tribunais personalidado */
		$scope.closeSources = (checkboxes, arrow) => {
			$(document).on('click', function(e) {
				if (!$(e.target).is('.searchingSources')) {
					if ($scope.expandedSourcesFilter === true) {
						checkboxes.style.display = 'none';
						$scope.expandedSourcesFilter = false;
						arrow.style.transform = 'rotate(360deg)';
					}
				}
			});
		};

		/**
		 * Método detecta se houve alteração no filtro de fontes,
		 * para salvar id de fonte e valor do Parametro
		 */
		$scope.beforeFilterBySourceParams = (composedId = '') => {
			composedId = composedId.toString();

			const [processSourceId, parameterValueId] = composedId.split('.');

			$scope.filter.composedId = composedId;

			if (processSourceId) $scope.filter.fonte = processSourceId;

			if (parameterValueId) $scope.filter.valorParametro = parameterValueId;
		};

		$scope.sourcesSelected = sources => {
			$scope.filter.composedId = sources.composedId;
			$scope.titleSources = sources.nomeFontePesquisa;

			$scope.beforeFilterBySourceParams(
				$scope.filter.composedId,
				$scope.filter
			);
			// $scope.selectedFilter($scope.filter);

			$scope.expandedSources();
		};

		$scope.expandedSources = () => {
			const el = document.getElementById('inputBuscaFontes');

			if (el && el.value) {
				el.value = '';
			}

			$scope.sourcesClose = false;

			var checkboxes = document.getElementById('checkboxesSources');
			var arrow = document.getElementById('arrowSources');

			setTimeout(() => {
				$scope.closeSources(checkboxes, arrow);
			}, 100);

			if ($scope.requestedProcessesSourcesParams.hasNotItems())
				$scope.changedSources($scope.filter);

			if (!$scope.expandedSourcesFilter) {
				checkboxes.style.display = 'block';
				$scope.expandedSourcesFilter = true;

				arrow.style.transform = 'rotate(180deg)';
			} else {
				checkboxes.style.display = 'none';
				$scope.expandedSourcesFilter = false;

				arrow.style.transform = 'rotate(360deg)';
			}
		};

		/**
		 * Método que traz registros do filtro das fontes baseado no tribunal selecionado
		 */
		$scope.recordRequestedProcessesSourcesParams = () => {
			$scope.requestedProcessesSourcesParams.setReady(false);
			$scope.readySourcesParams = true;

			$scope.filterSources = $scope.filter.orgaoJudicial.toString();

			if ($scope.filterSources == $scope.previousFilterSources) {
				$scope.finishedSourcesLoading = false;

				let itens = $scope.lastSources || [];

				const sourceParamsList = [];

				itens.map(item => {
					const { idFontePesquisa, nomeFontePesquisa, parametros } = item;

					if (!parametros.length)
						sourceParamsList.push({
							composedId: idFontePesquisa,
							idFontePesquisa,
							nomeFontePesquisa
						});
					else
						parametros.map(param => {
							const { nomeValorParamFontePesq, idValorParamFontePesq } = param;

							sourceParamsList.push({
								composedId: `${idFontePesquisa}.${idValorParamFontePesq}`,
								idFontePesquisa,
								nomeFontePesquisa: `${nomeFontePesquisa} - ${nomeValorParamFontePesq}`,
								idValorParamFontePesq
							});
						});
				});

				$scope.requestedProcessesSourcesParams.setItems(sourceParamsList);

				if ($stateParams.composedId) {
					const c = sourceParamsList.filter(
						c => c.composedId == $stateParams.composedId
					);

					if (c.length === 1)
						$scope.recordsFilters.nomeFontePesquisa = c[0].nomeFontePesquisa;

					$scope.titleSources = $scope.requestedProcessesSourcesParams
						.getItems()
						.filter(
							item => item.composedId == $stateParams.composedId
						)[0].nomeFontePesquisa;
				}

				$scope.requestedProcessesSourcesParams.setReady(true);
				$scope.readySourcesParams = false;
				$scope.requestedProcessesSourcesParams.hasItems()
					? ($scope.notSources = false)
					: ($scope.notSources = true);

				$scope.finishedSourcesLoading = true;

				return;
			}

			$scope.previousFilterSources = $scope.filterSources;

			$scope.requestedProcessesSourcesParams.setItems([]);
			$scope.requestedProcessesSourcesParams.setReady(false);
			$scope.guardSources = null;

			if (!$scope.filterSources) {
				return;
			}

			$scope.finishedSourcesLoading = false;

			$http({
				...helper.http(API.requestedProcessesSourcesParams, 'GET'),
				params: {
					campos: '*',
					idOrgaoJudiciario: $scope.filterSources
				}
			})
				.then(({ data: { itens = [] } }) => {
					$scope.lastSources = itens;

					const sourceParamsList = [];

					itens.map(item => {
						const { idFontePesquisa, nomeFontePesquisa, parametros } = item;

						if (!parametros.length)
							sourceParamsList.push({
								composedId: idFontePesquisa,
								idFontePesquisa,
								nomeFontePesquisa
							});
						else
							parametros.map(param => {
								const {
									nomeValorParamFontePesq,
									idValorParamFontePesq
								} = param;

								sourceParamsList.push({
									composedId: `${idFontePesquisa}.${idValorParamFontePesq}`,
									idFontePesquisa,
									nomeFontePesquisa: `${nomeFontePesquisa} - ${nomeValorParamFontePesq}`,
									idValorParamFontePesq
								});
							});
					});

					$scope.requestedProcessesSourcesParams.setItems(sourceParamsList);

					if ($stateParams.composedId) {
						const c = sourceParamsList.filter(
							c => c.composedId == $stateParams.composedId
						);

						if (c.length === 1)
							$scope.recordsFilters.nomeFontePesquisa = c[0].nomeFontePesquisa;

						$scope.titleSources = $scope.requestedProcessesSourcesParams
							.getItems()
							.filter(
								item => item.composedId == $stateParams.composedId
							)[0].nomeFontePesquisa;
					}
				})
				.finally(() => {
					$scope.requestedProcessesSourcesParams.setReady(true);
					$scope.readySourcesParams = false;
					$scope.requestedProcessesSourcesParams.hasItems()
						? ($scope.notSources = false)
						: ($scope.notSources = true);
					$scope.finishedSourcesLoading = true;
				});
		};

		$scope.applyFilters = (filters, responseStore) => {
			$scope.requestingFilter = true;

			$scope.finishedFilterLoading = false;
			$scope.foundProcessesIndividual.setItems([]);

			const processes = $scope.foundProcessesIndividual.items.length;

			responseStore.setCurrentPage(1);

			let params = {
				...helper.httpFields(['*']),
				paginaAtual: 1,
				registrosPorPagina: responseStore.getItemsPerPage()
			};

			if (!!$scope.filter.situacao) {
				const {
					idClassifRetornoSpider,
					idSituacaoPesquisaProcessoUsuarioCliente,
					possuiFonteProcesso,
					movimentado
				} = $scope.sitClassifRetornoSpiders[$scope.filter.situacao];

				params.idSituacaoPesquisaProcessoUsuarioCliente = idSituacaoPesquisaProcessoUsuarioCliente;
				params.idsClassifRetornoSpider = idClassifRetornoSpider;
				params.possuiFonteProcesso = possuiFonteProcesso;
				params.movimentado = movimentado;
			} else {
				params.idSituacaoPesquisaProcessoUsuarioCliente = '-5,-6';
			}

			if ($scope.groupSelected == 'true') {
				params = Object.assign(filters, {
					idGrupoUsuarios: groupUserData.idGrupo
				});
			}

			if (!!$scope.filter.orgaoJudicial) {
				params.idsOrgaoJudiciario = $scope.filter.orgaoJudicial;
			}

			if (!!$scope.filter.fonte) {
				params.idsFontePesquisa = $scope.filter.fonte;
			}

			$http({
				...helper.http(API.foundProcesses, 'GET'),
				params
			})
				.then(response => {
					const totalProcess = response.data.itens.length;

					if (totalProcess === 0 && processes > 20) $scope.topButton = true;

					response.data.itens = response.data.itens.map(proc => ({
						...proc,
						fontes: proc.fontes.sort((fontA, fontB) => {
							const fontADate = fontA.dataHoraUltSolic;
							const fontBDate = fontB.dataHoraUltSolic;

							if (fontADate > fontBDate) return -1;

							if (fontADate < fontBDate) return 1;

							return 0;
						})
					}));

					response.data.itens.sort((processA, processB) => {
						const processADate = processA.fontes[0].dataHoraUltSolic;
						const processBDate = processB.fontes[0].dataHoraUltSolic;

						if (processADate > processBDate) return -1;

						if (processADate < processBDate) return 1;

						return 0;
					});

					if (responseStore.getCurrentPage() === 1)
						responseStore.setItems(response.data.itens);
					else responseStore.pushItems(response.data.itens);
				})
				.finally(() => {
					responseStore.setReady(true);

					$scope.processloading = false;
					$scope.loadingPage = false;
					$scope.finishedLoading = true;
					$scope.finishedFilterLoading = true;

					$scope.requestingFilter = false;

					const el = document.getElementById('inputBuscaFontes');

					if (el && el.value) {
						el.value = '';
					}

					if ($scope.expandedSourcesFilter) {
						var checkboxes = document.getElementById('checkboxesSources');
						var arrow = document.getElementById('arrowSources');

						checkboxes.style.display = 'none';
						$scope.expandedSourcesFilter = false;
						arrow.style.transform = 'rotate(360deg)';
					}
				});
		};

		$scope.clearSearch = (f, arr) => {
			arr.forEach(item => (f[item] = undefined));
			$state.go($state.current.name, f, { reload: true });
		};

		$scope.addListenerToScroll = () => {
			const courtsScroll =
				document.getElementById('courts-scroll') ||
				document.getElementById('courts-scroll-mobile');

			if (!courtsScroll || !$scope.clientUserJudicialOrgansList.hasItems())
				return;

			const checkBottomAndFetch = () => {
				const nearBottom =
					courtsScroll.scrollHeight -
						(courtsScroll.scrollTop + courtsScroll.clientHeight) <=
					2;

				if (
					nearBottom &&
					$scope.courtsPage.paginaAtual < $scope.courtsPage.paginaTotal &&
					!$scope.hasCourtsRequest
				) {
					$scope.scrollTopValue = courtsScroll.scrollTop;
					$scope.hasCourtsRequest = true;

					$scope.$applyAsync(() => {
						$scope.fetchNotificationNextPage();
					});
				}
			};

			if ($scope.hasCourtsScrollListener) {
				checkBottomAndFetch();

				return;
			}

			$scope.hasCourtsScrollListener = true;

			const handler = () => checkBottomAndFetch();

			courtsScroll.addEventListener('scroll', handler, { passive: true });
			courtsScroll.addEventListener('touchmove', handler, { passive: true });
			courtsScroll.addEventListener('touchend', handler, { passive: true });

			courtsScroll.addEventListener('pointermove', handler, { passive: true });
			courtsScroll.addEventListener('pointerup', handler, { passive: true });

			// checkBottomAndFetch();

			$scope.$on('$destroy', () => {
				courtsScroll.removeEventListener('scroll', handler);
				courtsScroll.removeEventListener('touchmove', handler);
				courtsScroll.removeEventListener('touchend', handler);
				courtsScroll.removeEventListener('pointermove', handler);
				courtsScroll.removeEventListener('pointerup', handler);
			});
		};

		$scope.openProcessFolder = item => {
			if (item.processosEncontrados == 0) {
				return;
			}

			$state.go('root.default.addProcessesOab', {
				id: item.idPesqProcOABXParamUsCliente
			});
		};

		$scope.fetchNotificationNextPage = () => {
			$scope.hasCourtsRequest = true;
			let paginaAtual = $scope.courtsPage.paginaAtual + 1;

			if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
				$rootScope.$apply();
			}

			$scope.updateScrollHeight(34);

			const paramsSearch = {
				SituacoesPesquisa: '-5,-6',
				campos: 'idOrgaoJudiciario,nomeOrgaoJudiciario,siglaOrgaoJudiciario',
				paginaAtual: paginaAtual,
				registrosPorPagina: 10,
				NomeOrgaoJudiciario: $scope.buscaTribunal
			};

			$scope.$applyAsync(() => {
				$scope.clientUserJudicialOrgansList.setReady(false);

				$scope.completedSearchCourts = false;
			});

			$http({
				...helper.http(API.requestedProcessesJudicialOrgans, 'GET'),
				params: paramsSearch
			})
				.then(response => {
					const itens = (response.data && response.data.itens) || [];

					$scope.courtsPage = response.data.paginacao;

					let courts = $scope.clientUserJudicialOrgansList.getItems();

					courts = [...courts, ...itens];

					$scope.clientUserJudicialOrgansList.setItems(courts);

					if ($stateParams.orgaoJudicial) {
						const o = itens.filter(
							o => o.idOrgaoJudiciario == $stateParams.orgaoJudicial
						);

						if (o.length === 1)
							$scope.recordsFilters.nomeOrgaoJudiciario =
								o[0].nomeOrgaoJudiciario;
					}
				})
				.finally(() => {
					$scope.hasCourtsRequest = false;

					$scope.$applyAsync(() => {
						$scope.clientUserJudicialOrgansList.setReady(true);

						$scope.completedSearchCourts = true;
					});

					if ($stateParams.orgaoJudicial) {
						$scope.titleCourts = $scope.clientUserJudicialOrgansList
							.getItems()
							.filter(
								item => item.idOrgaoJudiciario == $stateParams.orgaoJudicial
							)[0].nomeOrgaoJudiciario;
					}

					$scope.clientUserJudicialOrgansList.hasItems()
						? ($scope.notCourts = false)
						: ($scope.notCourts = true);

					setTimeout(() => {
						$scope.updateScrollHeight();
					}, 100);
				});
		};

		$scope.changeActiveTab = newTab => {
			if (newTab) {
				localStorage.setItem('__activeTab__', newTab);

				$scope.activeTab = newTab;
			}
		};

		$scope.getScroll();

		$scope.isMobile =
			window && window.innerWidth && window.innerWidth <= 991 ? true : false;

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;

			$scope.isMobile = window.innerWidth <= 991;

			if ($scope.isMobile != previousIsMobile) {
				$scope.$apply();
			}
		});

		$scope.onInit();
	}
]);

export default controller;
